import { getMondayOfWeek } from '../../utils/date';
import Booking from '../../types/model/Booking';
import EntityName from '../../enums/EntityName';

import { defaultEntityState } from '../entity/types';
import { generateEntityReducer } from '../entity/generateEntityReducer';

import Actions from '../Actions';
import { BookingFilters, BookingsState, defaultBookingFilters } from './types';
import ActionTypes from '../actionTypes';
import { StateStatus } from '../../enums/StateStatus';

export const defaultBookingsState: BookingsState = {
  ...defaultEntityState,
  selectedProjectId: 0,
  selectedDate: getMondayOfWeek(),
  selectedBooking: null,
  filters: defaultBookingFilters,
  blockedBookings: null,
  modal: { isOpen: false, data: null },
  editModal: false
};

const bookingEntityReducer = generateEntityReducer<Booking>(EntityName.Booking);

const bookingReducer = (state: BookingsState = defaultBookingsState, action: Actions): BookingsState => {
  // eslint-disable-next-line no-param-reassign
  state = bookingEntityReducer(state, action) as BookingsState;
  const { payload } = action as any;

  switch (action.type) {
    case ActionTypes.OPEN_EDIT_BOOKINGS_MODAL: {
      return {
        ...state,
        editModal: true
      };
    }
    case ActionTypes.CLOSE_EDIT_BOOKINGS_MODAL:
      return {
        ...state,
        editModal: false,
        selectedBooking: null
      };

    case ActionTypes.EDIT_BOOKING_SUCCESS: {
      const { bookingId, booking } = action.payload;
      return {
        ...state,
        byId: {
          ...state.byId,
          [bookingId]: {
            ...state.byId[bookingId],
            ...booking
          }
        }
      };
    }

    case ActionTypes.CHANGE_SELECTED_DATE:
      return {
        ...state,
        selectedDate: action.payload
      };

    case ActionTypes.BLOCK_BOOKING_SLOT_SUCCESS:
      return {
        ...state,
        blockedBookings: action.payload
      };

    case ActionTypes.CHANGE_SELECTED_PROJECT:
      return {
        ...state,
        selectedProjectId: action.payload
      };

    case ActionTypes.CHANGE_FILTERS: {
      const filters = payload as BookingFilters;
      return {
        ...state,
        filters
      };
    }

    case ActionTypes.RESET_FILTERS: {
      return {
        ...state,
        filters: defaultBookingFilters
      };
    }

    case ActionTypes.OPEN_BOOKING_MODAL:
      return {
        ...state,
        modal: {
          isOpen: true,
          data: payload
        }
      };

    case ActionTypes.CLOSE_BOOKING_MODAL:
      return {
        ...state,
        modal: {
          isOpen: false,
          data: null
        }
      };

    case ActionTypes.OPEN_BOOKING_DETAILS:
      return {
        ...state,
        selectedBooking: payload
      };

    case ActionTypes.CLOSE_BOOKING_DETAILS:
      return {
        ...state,
        selectedBooking: null
      };

    case ActionTypes.REMOVE_BOOKING_SLOTS_PER_DAY_SUCCESS:
    case ActionTypes.UNBLOCK_ALL_DATES_SUCCESS:
    case ActionTypes.UNBLOCK_DATE_SUCCESS:
      return {
        ...state,
        status: StateStatus.Loaded
      };

    case ActionTypes.SET_BOOKING_STATUS:
    case ActionTypes.BLOCK_BOOKING_SLOT:
    case ActionTypes.REMOVE_BOOKING_SLOTS_PER_DAY:
    case ActionTypes.UNBLOCK_ALL_DATES:
    case ActionTypes.UNBLOCK_DATE:
      return {
        ...state,
        status: StateStatus.Busy,
        error: null
      };
    case ActionTypes.SET_BOOKING_STATUS_SUCCESS: {
      const booking = payload as Booking;
      return {
        ...state,
        status: StateStatus.Loaded,
        byId: {
          ...state.byId,
          [booking.id]: booking
        }
      };
    }
    case ActionTypes.SET_BOOKING_STATUS_ERROR:
    case ActionTypes.BLOCK_BOOKING_SLOT_ERROR:
    case ActionTypes.REMOVE_BOOKING_SLOTS_PER_DAY_ERROR:
    case ActionTypes.UNBLOCK_ALL_DATES_ERROR:
    case ActionTypes.UNBLOCK_DATE_ERROR:
      return {
        ...state,
        status: StateStatus.Error,
        error: action.payload
      };

    default:
      return state;
  }
};

export default bookingReducer;
